import type { DalError, DalReturn } from "@/core/dal/data.type";
import { dalDbOperation } from "@/core/dal/helper";
import type { AvailableAircraftSearchData } from "@/core/schemas/available-aircraft.schema";
import type ApiService from "@/core/services/api.service";
import type APIEndpointsService from "@/core/services/api-endpoints.service";
import type { AircraftProfile } from "@/core/types/aircraft.type";

class AvailableAircraftService {
	constructor(
		private apiService: ApiService,
		private apiEndpointsService: APIEndpointsService,
	) {}

	retrieveAvailableAircraft(
		data: AvailableAircraftSearchData,
	): Promise<DalReturn<AircraftProfile[], DalError>> {
		return dalDbOperation(() =>
			this.apiService.post<AircraftProfile[]>(
				this.apiEndpointsService.getRoutes().availableAircraft.post(),
				data,
			),
		);
	}
}

export default AvailableAircraftService;
